import React from "react";
import glamorous from "glamorous";
import _ from "lodash";

import { SelectFilterButton, DateRangeFilterButton } from "./FilterButtons";
import Colors from "../../styles/colors";
import { getLadLobLabel } from "../../components/lads";

const FilterContainer = glamorous.div(
  {
    display: "flex",
    flexFlow: "row wrap",
    borderRadius: "3px",
    borderTopRightRadius: "0px",
    paddingLeft: "0.5em",
    marginBottom: "0.5em",
    paddingRight: "12em"
  },
  ({ show = false, backgroundColor = Colors.background.LIGHT_GRAY }) => ({
    backgroundColor: backgroundColor,
    overflow: show ? "visible" : "hidden",
    maxHeight: show ? "12em" : "0em",
    transition: show ? "max-height 0.4s ease-in" : "max-height 0.4s ease-out"
  })
);

class FilterSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      toggledFilter: null
    };

    this.toggleFilter = this.toggleFilter.bind(this);
    this.isFilterToggled = this.isFilterToggled.bind(this);
  }

  toggleFilter(filter) {
    if (this.state.toggledFilter === filter) {
      this.setState({ toggledFilter: null });
    } else {
      this.setState({ toggledFilter: filter });
    }
  }

  isFilterToggled(filter) {
    return this.props.show && filter === this.state.toggledFilter;
  }

  render() {
    const {
      show,
      locations,
      exceptionTypes,
      statusTypes,
      shipmentModes,
      carriers,
      backgroundColor,
      lads,
      organizations
    } = this.props;

    const currentOrganizationId = sessionStorage.getItem("currentOrganization");
    const organization = _.find(organizations, {
      organization_id: Number(currentOrganizationId)
    });
    const isCarrier = organization
      ? organization.org_type === "Carrier"
      : false;

    const locationsOptions = locations.map(l => {
      return { value: l.id, label: l.name };
    });
    const exceptionTypeOptions = exceptionTypes.map(e => {
      return { value: e.id, label: e.name };
    });
    const statusTypeOptions = statusTypes.map(s => {
      return { value: s.id, label: s.name };
    });
    const shipmentModeOptions = shipmentModes.map(m => {
      return { value: m.id, label: m.name };
    });
    const carrierOptions = carriers.map(c => {
      return { value: c.id, label: c.name };
    });

    const ladOptions = lads.map(l => {
      return { value: l.id, label: getLadLobLabel(l) };
    });

    return (
      <div>
        <FilterContainer show={show} backgroundColor={backgroundColor}>
          <SelectFilterButton
            filterKey={"origin"}
            label={"Origin"}
            toggled={this.isFilterToggled("origin")}
            onToggle={this.toggleFilter}
            options={locationsOptions}
          />
          <SelectFilterButton
            filterKey={"destination"}
            label={"Destination"}
            toggled={this.isFilterToggled("destination")}
            onToggle={this.toggleFilter}
            options={locationsOptions}
          />
          {isCarrier ? null : (
            <SelectFilterButton
              filterKey={"carrier"}
              label={"Carrier"}
              toggled={this.isFilterToggled("carrier")}
              onToggle={this.toggleFilter}
              options={carrierOptions}
            />
          )}
          <DateRangeFilterButton
            filterKey={"pickup"}
            label={"Pickup Date"}
            toggled={this.isFilterToggled("pickup")}
            onToggle={this.toggleFilter}
          />
          <DateRangeFilterButton
            filterKey={"delivery"}
            label={"Delivery Date"}
            toggled={this.isFilterToggled("delivery")}
            onToggle={this.toggleFilter}
          />
          <SelectFilterButton
            filterKey={"mode"}
            label={"Mode"}
            toggled={this.isFilterToggled("mode")}
            onToggle={this.toggleFilter}
            options={shipmentModeOptions}
          />
          {isCarrier ? null : (
            <SelectFilterButton
              filterKey={"location_type"}
              label={"Location Type"}
              toggled={this.isFilterToggled("location_type")}
              onToggle={this.toggleFilter}
              options={ladOptions}
            />
          )}
          <SelectFilterButton
            filterKey={"status"}
            label={"Status"}
            toggled={this.isFilterToggled("status")}
            onToggle={this.toggleFilter}
            options={statusTypeOptions}
          />
          <SelectFilterButton
            filterKey={"active_exception"}
            label={"Active Exception"}
            toggled={this.isFilterToggled("active_exception")}
            onToggle={this.toggleFilter}
            options={exceptionTypeOptions}
          />
        </FilterContainer>
      </div>
    );
  }
}

export default FilterSection;



// WEBPACK FOOTER //
// ./src/modules/shipment-search/FilterSection.js